import { type ReactNode } from 'react'
import { Tooltip as BootstrapTooltip, OverlayTrigger, type OverlayTriggerProps } from 'react-bootstrap'
import { type TooltipProps as BootstrapTooltipProps } from 'react-bootstrap/Tooltip'

import './Tooltip.scss'
export interface TooltipProps extends BootstrapTooltipProps {
  title?: string
  tooltipContent?: ReactNode
  placement?: OverlayTriggerProps['placement']
  offset?: OverlayTriggerProps['offset']
}

export const Tooltip: React.FC<TooltipProps> = ({ title, className, placement, offset, children, tooltipContent, ...rest }) => {
  if (!title && !tooltipContent) {
    return <span>{children}</span>
  }

  return (
    <OverlayTrigger
      placement={placement}
      offset={offset}
      overlay={
        <BootstrapTooltip className={className} {...rest}>
          {tooltipContent ?? title}
        </BootstrapTooltip>
      }
    >
      <span>{children}</span>
    </OverlayTrigger>
  )
}
